/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import { AuditNavigationTrace } from "../../types/AuditNavigationTrace";
import { AUDITNAVIGATIONTRACES, GLOBALSETTINGS, SYSTEMSETTINGS } from "../../data/constants";
import useApi from "../../hooks/useApi";
import { GetAllFilesAndFoldersByUserDto } from "../../types/FolderPermission";
import { getRecentViewedItems } from "../../services/roleService";
import { RecentViewedRequestDto } from "../../types/Role";
import { useUser } from "../../context/UserContext";
import { FolderFileType } from "../../data/Enums";
import RecentViewedItems from "./RecentViewedItems";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { clearRecentViewedFile } from "../../redux/recentViewedSlice";
import { useSettingValue } from "../../services/useSettingValue";
import { getSavedRecentItems } from "../../utils/commonHelper";

const SuggestedFiles: React.FC = () => {
  const [fileData, setFileData] = useState<GetAllFilesAndFoldersByUserDto[]>([]);
  const { executeApi } = useApi();
  const dispatch = useDispatch();
  const { userId } = useUser();
  const { triggerFile } = useSelector((state: RootState) => state.recentViewedUpdated);
  const settingValue = useSettingValue(SYSTEMSETTINGS.RECENT_VIEWEDITEMS);

  const getRecentViewedFiles = useCallback(async () => {
    const displaySizeNumber = parseInt(settingValue ?? GLOBALSETTINGS.DEFAULT_VALUE, 10);
    const recentlyViewed: AuditNavigationTrace[] = JSON.parse(
      localStorage.getItem(AUDITNAVIGATIONTRACES.RECENT_VIEWED_FILES) || "[]"
    );

    let latestRecentlyViewed = null;
    const recentlyViewedFiles = recentlyViewed
      .filter((item) => item.objectType === FolderFileType[FolderFileType.File] && item.objectId)
      .filter((item, index, self) => index === self.findIndex((t) => t.objectId === item.objectId));
    if (recentlyViewedFiles && recentlyViewedFiles.length > 0) {
      const sortedRecentlyViewed = recentlyViewedFiles.sort((a, b) => {
        return new Date(b.navigationDateTime).getTime() - new Date(a.navigationDateTime).getTime();
      });
      // Get the latest items based on the displaySizeNumber
      latestRecentlyViewed = sortedRecentlyViewed.slice(0, displaySizeNumber);
    }
    let objectIds = null;
    if (latestRecentlyViewed && latestRecentlyViewed.length > 0) {
      objectIds = latestRecentlyViewed.map((item) => item.objectId).join(",");
    }
    const recentViewedRequestDto: RecentViewedRequestDto = {
      userId: userId,
      folderFileType: FolderFileType.File,
      typeId: objectIds?.toString(),
      displaySize: displaySizeNumber,
    };

    const fileDetails = await executeApi<RecentViewedRequestDto, GetAllFilesAndFoldersByUserDto[]>(
      getRecentViewedItems,
      recentViewedRequestDto
    );
    if (fileDetails) {
      setFileData(fileDetails);
      if (objectIds === null) {
        getSavedRecentItems(fileDetails, userId, FolderFileType.File);
      }
    }
  }, [userId]);

  useEffect(() => {
    getRecentViewedFiles();
  }, [getRecentViewedFiles]);

  useEffect(
    () => {
      if (triggerFile > -1) {
        getRecentViewedFiles();
        dispatch(clearRecentViewedFile());
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [triggerFile]
  );

  if (fileData.length === 0) {
    return null;
  }

  return <RecentViewedItems lastViewedItems={fileData} folderFileType={FolderFileType.File} />;
};

export default SuggestedFiles;
